import { useLanguageStore } from '@/pinia/language'
import { usePlugin } from './usePlugin'

export const useGoogleImageTranslate = () => {
  const { $toast } = usePlugin()
  const language = useLanguageStore()

  const translate = async (image, text) => {
    try {
    // 1. 加载图片并转换为 Bitmap
      const response = await fetch(image)
      const blob = await response.blob()
      const bitmap = await createImageBitmap(blob)

      // 2. 绘制到 Canvas 并导出为 PNG
      const canvas = document.createElement('canvas')
      canvas.width = bitmap.width
      canvas.height = bitmap.height
      const ctx = canvas.getContext('2d')
      ctx.drawImage(bitmap, 0, 0)

      // 3. 将 Canvas 转换为 Blob (PNG)
      const pngBlob = await new Promise((resolve) =>
        canvas.toBlob(resolve, 'image/png')
      )

      // 4. 写入剪贴板
      const clipboardItem = new ClipboardItem({ 'image/png': pngBlob })
      await navigator.clipboard.write([clipboardItem])

      $toast('Copy Successfully')
      const tl = language.current.replace('zh', 'zh-CN')
      window.open(
      `https://translate.google.com/?sl=auto&tl=${tl}&text=${text}&op=images`
      )
    } catch (error) {
      console.error('复制失败:', error)
      console.error('复制失败:', error.message)

      $toast('Copy Error', { type: 'error' })
    }
  }

  return { translate }
}
